module.exports = __webpack_public_path__ + "static/media/happiness-logo.d2e9feed.svg";